import React from 'react'
import PropTypes from 'prop-types'

import { Link } from '@/components/common'

const LearnMoreCta = ({ href, ...rest }) => (<Link
  external
  messageId="cta.learnMore"
  openTab
  size="large"
  to={href}
  variant="secondary"
  {...rest}
/>)

LearnMoreCta.propTypes = {
  href: PropTypes.string.isRequired,
}

export default LearnMoreCta
